import React from "react";
import "../css/FooterSection.css";
import { Link } from "react-router-dom";
const FooterSection = () => {
  return (
    <div className="footer-layout-wrapper">
      {}
      <section className="cta-enquiry-banner">
        <div className="cta-container">
          <h2 className="cta-text">
            Looking for a trusted SEEB school in Nepal for your child? Connect
            with Sahara Public Secondary School to explore admissions, campus
            experience, and the right learning pathway.
          </h2>

          <Link to="/contact" className="enquiry-btn">
            Enquiry Now <i>›</i>
          </Link>
        </div>
      </section>

      {}
      <footer className="main-footer">
        <div className="footer-container">
          {}
          <div className="footer-left-col">
            <h3 className="campus-title">
              Sahara Public Secondary School Nepal Campus
            </h3>

            {}
            <div className="campus-card">
              <img
                src="../images/campus.jpg"
                alt="GIIS Ahmedabad Campus Building"
                className="campus-img"
              />
              <div className="campus-card-overlay">
                <div className="contact-item address">
                  <span className="geo-icon">📍</span>
                  <p>
                    Krishna Nagar Municipality, Ward No. 02, District:
                    Kapilvastu Lumbini, Nepal.
                  </p>
                </div>
                <div className="contact-item phone">
                  <span className="phone-icon">📞</span>
                  <a href="tel:18005722810">+977 984-7040404</a>
                </div>
              </div>
            </div>

            {}
            <div className="social-links-row">
              <a
                href="https://www.youtube.com/@sahara.school"
                className="social-icon-circle"
                aria-label="YouTube"
              >
                ▶
              </a>
              <a
                href="https://www.facebook.com/sahara.edu.np"
                className="social-icon-circle"
                aria-label="Facebook"
              >
                f
              </a>
              <a
                href="#"
                className="social-icon-circle"
                aria-label="X (formerly Twitter)"
              >
                𝕏
              </a>
              <a
                href="https://www.linkedin.com/company/114864139/admin/page-posts/published/"
                className="social-icon-circle"
                aria-label="LinkedIn"
              >
                in
              </a>
              <a
                href="https://www.instagram.com/sahara.edu.np/"
                className="social-icon-circle"
                aria-label="Instagram"
              >
                📸
              </a>
            </div>
          </div>

          {}
          <div className="footer-right-col">
            <div className="vertical-divider-line"></div>

            <div className="badges-grid-wrapper">
              {}
              <div className="badge-item efqm-box">
                <div className="efqm-logo">∞</div>
                <div className="badge-meta-text">
                  <strong>EFQM</strong>
                  <span>MEMBER</span>
                </div>
              </div>

              {}
              <div className="badge-item iso-box">
                <div className="iso-shield">✔</div>
                <div className="badge-meta-text">
                  <strong>ISO 9001: 2015</strong>
                  <span className="cert-num">
                    Certificate Number: 17826-Q15-001
                  </span>
                </div>
              </div>

              {}
              <div className="badge-item iso-box">
                <div className="iso-shield">✔</div>
                <div className="badge-meta-text">
                  <strong>ISO 45001: 2018</strong>
                  <span className="cert-num">
                    Certificate Number: 17826-OHS-001
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FooterSection;
